import { useTranslations } from "contexts/LocalizationContext";
import { ChakraButton as Button } from "@airhelp/react-ui-components";
import config from "config/config";

export const LogInButton = () => {
  const translations = useTranslations();
  return (
    <Button
      key="button_login"
      variant="primary"
      href={`${config.webappUrl}/plus`}
      color="white"
      ml={{ lg: 1, xl: 8 }}
      px={{ lg: 3, xl: 6 }}
      title={translations("button_login")}
      as="a"
      _visited={{}}
      data-testid="top-navbar-login-airhelp-plus"
      textAlign="center"
    >
      {translations("button_login")}
    </Button>
  );
};
